import { Validator } from '@vista-digital/validator';
/**
 * Default display labels for the Single Filter component.
 */
export const defaultSingleFilterDisplayText = {
    modalLabel: 'Filter',
    allOptionLabel: undefined,
    cancelButtonLabel: 'Cancel',
    noSearchResultsFoundMessage: undefined
};
export const singleFilterDisplayTextValidator = Validator.object({
    modalLabel: Validator.nonEmptyString,
    allOptionLabel: Validator.optional(Validator.nonEmptyString),
    cancelButtonLabel: Validator.nonEmptyString,
    noSearchResultsFoundMessage: Validator.optional(Validator.nonEmptyString)
});
//# sourceMappingURL=display-text.js.map